import ListEmp from '../Component/pages/emp/listEmp';

function Emp() {
  return (
    <div><ListEmp /></div>
  )
}

export default Emp